var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"request-notification-container"},[_c('div',{class:_vm.getNotificationClass},[_c('p',[_vm._v(_vm._s(_vm.getNotificationMsg))]),_c('span',{staticClass:"fas fa-times clickable",on:{"click":_vm.closePop}})])])}
var staticRenderFns = []

export { render, staticRenderFns }